import { useQuery } from '@tanstack/react-query';

import { type LocationDetails } from '~entities/locations/modal/location';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const getAllLocationsAPI = async () => {
  const response = await baseAPI.get<Array<LocationDetails>>(
    `/custom-form/location`,
  );
  return response.data;
};

export const useGetAllLocations = () => {
  return useQuery({
    queryKey: [KEYS.LOCATIONS],
    queryFn: () => getAllLocationsAPI(),
  });
};
